// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f2942ea3","239":"28b8e5c8","455":"15719422"}[chunkId] + ".chunk.js";
};